// extracted by mini-css-extract-plugin
export default {"input":"VacationInput_input__aFKsj"};